import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../../../../core/common/app-constants';

interface Feature {
  icon: string;
  title: string;
  desc: string;
}

@Component({
selector: 'app-home-comp2',
standalone: true,
imports: [CommonModule],
templateUrl: './homecomp2.component.html',
styleUrls: ['./homecomp2.component.scss']
})

export class Homecomp2Component {
  private router = inject(Router);

// items = [
//     { icon: 'fa-cloud-arrow-up', title: 'Sin instalación', desc: 'Accede a tu información desde cualquier computadora, tanlet o celular.' },
//     { icon: 'fa-boxes-stacked', title: 'Soporte gratis 24/7', desc: 'Recibe soporte de un equipo especializado los 365 días del año..' },
//     { icon: 'fa-chart-line', title: 'Al día con la SUNAT', desc: 'Cumple fácil con cada requisito fiscal mediante actualizaciones automáticas.' },
//   ];

//   // Arreglo de servicios para la segunda sección
//   features: Feature[] = [
//     {
//       icon: '🚀', 
//       title: 'Implementación Rápida', 
//       desc: 'Activamos tu sistema de facturación o web QR en menos de 24 horas.'
//     },
//     {
//       icon: '🛠️', 
//       title: 'Soporte Técnico', 
//       desc: 'Contamos con un equipo backend y frontend listo para ayudarte siempre.'
//     },
//     {
//       icon: '📊', 
//       title: 'Panel de Control', 
//       desc: 'Gestiona tus ventas, stock y usuarios desde un administrador interno moderno.'
//     },
//     {
//       icon: '📱', 
//       title: 'Diseño Responsive', 
//       desc: 'Toda tu plataforma se adapta perfectamente a celulares, tablets y PC.'
//     },
//     {
//       icon: '🔒', 
//       title: 'Seguridad Total', 
//       desc: 'Tus datos y los de tus clientes están protegidos con certificados SSL.'
//     },
//     {
//       icon: '☁️', 
//       title: 'Nube Ilimitada', 
//       desc: 'Almacenamiento seguro para tus comprobantes y base de datos.'
//     }
//   ];

  sistemas: any[] = [
    {
      icon: '<i class="fa-solid fa-circle-dollar-to-slot"></i>',
      titulo: 'Ventas y Facturación Electrónica',
      descripcion: 'Sistema completo para gestionar tus ventas y emitir comprobantes directamente a SUNAT.',
      beneficios: ['Emisión directa a SUNAT', 'Boletas y facturas', 'Reportes de ventas'],
      url: AppConstants.routes.SYSTEM_FACTURACION
    },
    {
      icon: '<i class="fa-solid fa-qrcode"></i>',
      titulo: 'Encuéntrame',
      descripcion: 'Genera códigos QR inteligentes para objetos, mascotas o personas. Perfil seguro y geolocalización.',
      beneficios: ['Generación de QR', 'Perfil personalizable', 'Notificaciones'],
      url: AppConstants.routes.SYSTEM_ENCUENTRAME
    },
    {
      icon: '<i class="fa-solid fa-bag-shopping"></i>',
      titulo: 'Ventas Online',
      descripcion: 'Página web profesional para vender tus productos. Carrito de compras y gestión de pedidos.',
      beneficios: ['Catálogo de productos', 'Carrito de compras', 'Pasarela de pagos'],
      url: AppConstants.routes.SYSTEM_VENTASONLINE
    }
  ];

  masInfo(url: any){
    this.router.navigate([url]);
  }

}

